import React, { useEffect, useState } from 'react';
import { Form } from 'antd';
import { MagnifyingGlass, SlidersHorizontal, SquaresFour } from '@phosphor-icons/react';
import { InputCommon } from 'components/common/Input/InputCommon';
import SelectCommon from 'components/common/Select/SelectCommon';
import { useGetAllCategoriesQuery, useGetSuppliersQuery } from 'services';
import { SupplierFiltersProps } from 'types';
import { FilterCategoryTab, PriceRangeSlider } from 'components/common';
import FilterPopover from 'components/common/Filter/FilterPopover';
import { useMediaQuery } from 'react-responsive';

const SupplierFilters: React.FC<SupplierFiltersProps> = ({
  form,
  selectedSupplierId = '',
  setSelectedSupplierId,
  debouncedSetSearchName,
  setSearchCategory,
  setPriceRange,
  setSortValue,
  className = '',
}) => {
  const [priceRangeTmp, setPriceRangeTmp] = useState<number[]>([0, 50000000]);
  const { data: suppliers } = useGetSuppliersQuery({
    query: {
      include: 'baseUser',
    },
  });
  const min = 0;
  const max = 50000000;
  const { data: categories, isLoading: isLoadingCategories } = useGetAllCategoriesQuery({
    query: { size: 'unlimited', include: 'parent' },
  });

  const isDesktop = useMediaQuery({ minWidth: 1240 });

  // State cho FilterCategoryTab
  const [selectedCategoryId, setSelectedCategoryId] = useState<string | null>(null);
  const [filterCategorys, setFilterCategorys] = useState<string[]>([]);

  const handleSelectCategory = (categoryId: string | null) => {
    setSelectedCategoryId(categoryId);
    setFilterCategorys([]);
    setSearchCategory(categoryId ?? '');
  };
  useEffect(() => {
    console.log('selectedSupplierId', selectedSupplierId);
  }, [selectedSupplierId]);
  const filterContent = (
    <div className='flex lg:flex-row flex-col gap-3 '>
      <Form.Item className='mb-0 w-full'>
        <SelectCommon
          placeholderSelect='Chọn nhà cung cấp'
          placeholder='Chọn nhà cung cấp'
          selectType='filterSelect'
          widthSelect='220px'
          className='bg-white'
          variant='borderless'
          value={selectedSupplierId}
          options={[
            { label: 'Tất cả', value: '' },
            ...(suppliers?.data?.rows?.map((cat) => ({
              label: cat.baseUser?.name || '',
              value: cat.id,
            })) || []),
          ]}
          onChange={(value) => {
            form.setFieldValue('supplierId', value);
            setSelectedSupplierId(value);
          }}
        />
      </Form.Item>
      <Form.Item className='mb-0 w-full'>
        <SelectCommon
          suffixIcon={<SquaresFour size={16} className='text-black' />}
          placeholderSelect='Danh mục'
          selectType='filterSelect'
          widthSelect='220px'
          loading={isLoadingCategories}
          className='bg-white'
          variant='borderless'
          onSelect={(value: string) => handleSelectCategory(value)}
          options={[
            { label: 'Tất cả', value: '' },
            ...(categories?.data?.rows?.map((cat) => ({
              label: cat.name || '',
              value: cat.id,
            })) || []),
          ]}
        />
      </Form.Item>
      <Form.Item className='mb-0 w-full'>
        <PriceRangeSlider
          width='220px'
          value={priceRangeTmp}
          onChange={(value: number[]) => {
            if (min === value[0] && max === value[1]) {
              setPriceRange([]);
            } else {
              setPriceRange(value);
            }
            setPriceRangeTmp(value);
          }}
          min={min}
          max={max}
        />
      </Form.Item>
      <Form.Item className='mb-0 w-full'>
        <SelectCommon
          placeholderSelect='Sắp xếp theo'
          selectType='filterSelect'
          widthSelect='220px'
          className='bg-white'
          variant='borderless'
          options={[
            { label: 'Tên (A → Z)', value: 'name:asc' },
            { label: 'Tên (Z → A)', value: 'name:desc' },
            { label: 'Giá tăng dần', value: 'salePrice:asc' },
            { label: 'Giá giảm dần', value: 'salePrice:desc' },
          ]}
          onChange={(value) => {
            setSortValue(value);
          }}
        />
      </Form.Item>
    </div>
  );

  return (
    <div className={`w-full ${className}`}>
      <FilterCategoryTab
        categories={categories?.data?.rows || []}
        className='!mt-0'
        selectedCategoryId={selectedCategoryId}
        onSelectCategory={handleSelectCategory}
        allQuantity={0}
        setFilterCategorys={setFilterCategorys}
        filterCategorys={filterCategorys}
        rowCount={1}
      />
      <Form form={form} layout='vertical' className='flex gap-3 '>
        <Form.Item className='mb-0 w-full'>
          <InputCommon
            onChange={(e) => debouncedSetSearchName(e.target.value)}
            variantStatus='underline'
            type='text'
            className='!h-[40px]'
            placeholder='Tìm kiếm theo tên hoặc mã sản phẩm...'
            suffix={<MagnifyingGlass size={16} />}
          />
        </Form.Item>

        {isDesktop ? (
          filterContent
        ) : (
          <FilterPopover
            icon={<SlidersHorizontal size={20} />}
            count={0}
            className='!bg-[var(--bgGreyColor)]  p-4 rounded-lg opacity-100'
          >
            {filterContent}
          </FilterPopover>
        )}
      </Form>
    </div>
  );
};

export default SupplierFilters;
